import Tooltip from "@mui/material/Tooltip"
import IconButton from "@mui/material/IconButton"
import InfoIcon from '@mui/icons-material/Info';
import useToggleState from "@components/_hooks/useToggleState";

const InfoTooltip = (props) => {
    const {
        className = "canvas-ignore",
        arrow,
        title,
        color = "primary"
    } = props;

    const {open, handleToggle, setOpen} = useToggleState();

    return (
        <Tooltip 
            className={className}
            arrow={arrow} 
            open={open} 
            onClick={handleToggle} 
            onMouseEnter={handleToggle} 
            onMouseLeave={() => setOpen(false)} 
            title={title}
        >
            <IconButton sx={{paddingLeft: {xs: 0, md: '8px'}}} aria-label="info">
                <InfoIcon 
                    sx={{
                        color: color
                    }}
                    fontSize="small" 
                />
            </IconButton>
        </Tooltip>
    )
}

export default InfoTooltip